
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsFuncKbMapShiftCodeGrid extends Serenity.EntityGrid<PsFuncKbMapShiftCodeRow, any> {
        protected getColumnsKey() { return PsFuncKbMapShiftCodeColumns.columnsKey; }
        protected getDialogType() { return PsFuncKbMapShiftCodeDialog; }
        protected getIdProperty() { return PsFuncKbMapShiftCodeRow.idProperty; }
        protected getInsertPermission() { return PsFuncKbMapShiftCodeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsFuncKbMapShiftCodeRow.localTextPrefix; }
        protected getService() { return PsFuncKbMapShiftCodeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}